/**
 * Smellish Geurnoten Tooltips
 * Beschrijvingen voor alle geurnoten - wordt automatisch toegepast op .note-item elementen
 */

const ScentTooltips = {
  // ======================== CITRUS ========================
  "bergamot": "Fris, elegant citrusfruit uit Zuid-Italië met een licht bloemige ondertoon",
  "citroen": "Helder, sprankelend en verkwikkend citrusaroma",
  "limoen": "Scherp, groen en verfrissend met een zesty karakter",
  "sinaasappel": "Zoet, zonnig en vrolijk citrusfruit",
  "mandarijn": "Zachte, zoete citrus met een speelse uitstraling",
  "grapefruit": "Bitter-zoet, energiek en opwekkend",
  "bloedsinaasappel": "Rijke, diepe citrus met rode-fruitaccenten",
  "yuzu": "Japanse citrus met een unieke, aromatische frisheid",
  "cedrat": "Intense, groene citrus met een kruidige kant",
  "pompelmoes": "Groot, sappig en verfrissend citrusfruit",
  "italiaanse-citroen": "Klassieke Amalfi-citroen, zonnig en authentiek",
  "groene-mandarijn": "Onrijpe mandarijn met een groen, fris karakter",
  "kumquat": "Kleine, intense citrus met eetbare schil",
  "citroenverbena": "Kruidig-citrus met een groene, aromatische noot",
  "citrusvruchten": "Mix van zonnige citrusgeuren",
  "pomerans": "Bittere sinaasappel, basis voor eau de cologne",

  // ======================== BLOEMIG ========================
  "roos": "Tijdloze, romantische bloemengeur vol elegantie",
  "jasmijn": "Sensueel, zoet en bedwelmend wit bloemetje",
  "ylang-ylang": "Exotisch, zoet en tropisch bloemig",
  "tuberoos": "Intens, crèmig en verleidelijk wit",
  "gardenia": "Rijk, romig en elegant wit bloemig",
  "magnolia": "Zacht, citrus-bloemig met een frisse uitstraling",
  "pioenroos": "Fris, romantisch en delicaat roze bloemig",
  "iris": "Poederig, elegant en verfijnd met een aardse ondertoon",
  "viooltje": "Poederig, zacht en nostalgisch bloemig",
  "lelie": "Statig, elegant en intens wit bloemig",
  "oranjebloesem": "Zoet, honingachtig en zomers bloemig",
  "frangipani": "Tropisch, crèmig en exotisch bloemig",
  "mimosa": "Poederig, zacht geel en lentachtig",
  "lavendel": "Aromatisch, kalmerend en tijdloos kruidig-bloemig",
  "fresia": "Fris, pepperig en delicaat bloemig",
  "hibiscus": "Tropisch, fruitig-bloemig met een zomerse vibe",
  "lotus": "Waterig, sereen en spiritueel bloemig",
  "orchidee": "Exotisch, crèmig en mysterieus",
  "zwarte-orchidee": "Donker, sensueel en geheimnisvoluit bloemig",
  "lelietje-van-dalen": "Delicaat, fris en lentachtig wit bloemetje",
  "lelietje van dalen": "Delicaat, fris en lentachtig wit bloemetje",
  "hyacint": "Intens, groen-bloemig met een frisse lentegeur",
  "narcis": "Groen, koel en elegant bloemig",
  "narcissen": "Groep voorjaarsbloemen met een frisse, groene geur",
  "jasmijnthee": "Delicate combinatie van thee en jasmijnbloesem",
  "arabische-jasmijn": "Rijke, intense jasmijn uit het Midden-Oosten",
  "damask-roos": "Klassieke, diepe rozensoort uit Damascus",
  "thee-roos": "Elegante roos met een subtiele thee-achtige geur",
  "turkse-roos": "Warme, kruidige rozenvariant",
  "bulgaarse-roos": "Premium roos, rijk en complex",
  "witte-bloemen": "Mix van elegante witte bloemsoorten",
  "appelbloesem": "Fris, lentachtig en onschuldig bloemig",
  "camelia": "Elegant, subtiel en verfijnd bloemig",
  "amaryllis": "Krachtig, elegant en feestelijk bloemig",
  "welriekende-lathyrus": "Zoet, romantisch en nostalgisch bloemig",
  "champaca": "Exotisch, intens en goudgeel bloemig",
  "tahitiaanse-gardenia": "Tropische variant met een crèmige, zoete geur",
  "bourbon-geranium": "Rozig, kruidig met een groene ondertoon",
  "neroli": "Elegant oranjebloesem-extract, fris en verfijnd",
  "heiligenbloem": "Kruidig-bloemig met een zonnige uitstraling",
  "blauwe-lotus": "Mystiek, waterig en spiritueel bloemig",
  "reseda": "Groen, honingachtig en subtiel bloemig",

  // ======================== HOUT ========================
  "sandelhout": "Crèmig, warm en meditatief houtig",
  "cederhout": "Droog, aromatisch en krachtig houtig",
  "vetiver": "Aards, rokerig en diep geworteld",
  "patchoeli": "Aards, kruidig en mysterieus donker",
  "oud": "Kostbaar, dierlijk en intens oosters hout",
  "guaiac-hout": "Rokerig, zoet en medicinaal houtig",
  "eikenhout": "Stevig, klassiek en betrouwbaar houtig",
  "teakhout": "Warm, exotisch en duurzaam houtig",
  "dennenhout": "Fris, bosachtig en verkwikkend groen",
  "berkenhout": "Licht, fris en aromatisch met teerachtige nuances",
  "cypressen": "Groen, fris en mediterraan houtig",
  "cipres": "Aromatisch, groen en eeuwig symbolisch",
  "den": "Fris, harzig en bosrijk groen",
  "ceder": "Warm, droog en majestueus houtig",
  "agarhout": "Zeldzaam, complex en diep aromatisch",
  "thanaka-hout": "Birmaans hout met een zacht, crèmig aroma",
  "droog-hout": "Warm, stoffig en natuurlijk houtig",
  "drijfhout": "Ziltig, verweerd en oceanisch houtig",
  "rode-ceder": "Warm, aromatisch met een roodachtige toon",
  "palissander-rozenhout": "Rozig-houtig, elegant en kostbaar",
  "ceder-uit-virginia": "Amerikaanse ceder, potlood-achtig en droog",
  "witte-ceder-extract": "Zacht, fris en lichthoutig",
  "mahonie": "Rijk, donker en luxueus tropisch hout",
  "akigalahout": "Zeldzaam Japans hout met een unieke geur",
  "berkehout": "Licht, aromatisch en subtiel houtig",
  "amberhout": "Warm, harzig en goudkleurig houtig",
  "witte-houtsoorten": "Lichte, frisse houtmix",
  "houtachtige-noten": "Algemene warme, aardse houtgeuren",

  // ======================== KRUIDEN & SPECERIJEN ========================
  "kaneel": "Warm, zoet en kruidig met een vleugje scherpte",
  "kruidnagel": "Intens, warm en aromatisch kruidig",
  "kardemom": "Fris, aromatisch en licht eucalyptusachtig",
  "gember": "Pittig, warm en verkwikkend",
  "peper": "Scherp, warm en stimulerend kruidig",
  "zwarte-peper": "Krachtig, scherp en verwarmend",
  "roze-peper": "Fruitig, licht en elegant pepperig",
  "nootmuskaat": "Warm, zoet en licht psychedelisch kruidig",
  "saffraan": "Kostbaar, honingachtig en intens kruidig",
  "komijn": "Aards, warm en exotisch kruidig",
  "kurkuma": "Aards, warm en goudgeel kruidig",
  "koriander": "Fris, citrusachtig en aromatisch kruidig",
  "steranijs": "Zoet, anijsachtig en oosters kruidig",
  "bourbon-peper": "Premium peper met een warme, complexe smaak",
  "ceylon-kaneel": "Fijne, zoete kaneel van topkwaliteit",
  "indonesische-nootmuskaat": "Intense, warme nootmuskaatvariant",
  "timur": "Tinteling gevende Nepalese peper",
  "karwijzaad": "Warm, aromatisch en licht anijsachtig",
  "kruidige-noten": "Mix van warme specerijen",

  // ======================== FRUIT ========================
  "appel": "Fris, knapperig en onschuldig fruitig",
  "rode-appel": "Zoet, sappig en verleidelijk rood",
  "peer": "Zacht, zoet en elegant fruitig",
  "perzik": "Fluweelzacht, zoet en zomers fruitig",
  "abrikoos": "Goudgeel, zoet en zonnig fruitig",
  "pruim": "Donker, sappig en rijk fruitig",
  "kers": "Zoet, sappig en romantisch rood",
  "kersen": "Rijpe, sappige rode vruchten",
  "zure-kers": "Pittig, fris en licht zuur fruitig",
  "framboos": "Zoet-zuur, rood en zomers fruitig",
  "braam": "Donker, sappig en bosachtig fruitig",
  "bosbes": "Klein, intens en blauw-paars fruitig",
  "aardbei": "Zoet, rood en onweerstaanbaar fruitig",
  "grote-aardbei": "Sappige, volle aardbeismaak",
  "passievrucht": "Exotisch, tropisch en intens fruitig",
  "mango": "Tropisch, zoet en zonnig fruitig",
  "papaja": "Crèmig, tropisch en zacht fruitig",
  "lychee": "Exotisch, bloemig-fruitig en delicaat",
  "kokosnoot": "Tropisch, crèmig en zomers",
  "vijg": "Zoet, groen en mediterraan fruitig",
  "granaatappel": "Robijnrood, zoet-zuur en antioxidantrijk",
  "sharonvrucht": "Zoet, honingachtig en zacht oranje",
  "watermeloen": "Verfrissend, waterig en zomers",
  "ananas": "Tropisch, zoet-zuur en zonnig",
  "cranberry": "Scherp, rood en fris-zuur",
  "rode-bes": "Klein, fris en helder rood fruitig",
  "moerbei": "Donker, zoet en zeldzaam fruitig",
  "dadels": "Karamelachtig, zoet en oosters fruitig",
  "gesuikerd-fruit": "Gekonfijt, zoet en nostalgisch",
  "kumquat": "Kleine citrus met zoete schil",

  // ======================== GROEN & AROMATISCH ========================
  "basilicum": "Fris, kruidig en aromatisch groen",
  "munt": "Koel, fris en verkwikkend groen",
  "rozemarijn": "Aromatisch, medicinaal en mediterraan groen",
  "tijm": "Kruidig, warm en aards aromatisch",
  "salie": "Kruidig, grijs-groen en reinigend",
  "groene-thee": "Fris, licht bitter en zen-achtig",
  "gras": "Fris gemaaid, groen en natuurlijk",
  "bamboe": "Fris, groen en oosters sereen",
  "tomatenblad": "Groen, kruidig en zomers aromatisch",
  "dragon": "Anijsachtig, groen en verfijnd kruidig",
  "komkommer": "Waterig, fris en verkoelend groen",
  "klimop": "Groen, fris en natuurlijk bosachtig",
  "schijnhulst": "Groenblijvend, fris en decoratief",
  "lisdodde": "Waterig, groen en moerasachtig fris",
  "groen-accoord": "Frisse, groene bladnoten",
  "cactus": "Groen, waterig en woestijnachtig fris",

  // ======================== HARSEN & BALSEMS ========================
  "wierook": "Heilig, rokerig en spiritueel harsig",
  "mirre": "Bitter, medicinaal en mystiek harsig",
  "benzoine": "Warm, vanilleachtig en balsemisch",
  "amber": "Warm, zoet en sensueel harsig",
  "lichte-amber": "Zachte, goudkleurige warmte",
  "labdanum": "Rijk, leerachtig en amberachtig harsig",
  "olibanum": "Zuivere wierook, heilig en verheffend",
  "elemi": "Fris, citrus-harsig en opwekkend",
  "elemi-hars": "Aromatische boomhars uit de Filipijnen",
  "tolubalsem": "Warm, vanilleachtig en zoet balsemisch",
  "harsen": "Mix van warme, aromatische boomharsen",

  // ======================== MUSK & AMBER ========================
  "muskus": "Sensueel, huidachtig en aantrekkelijk",
  "witte-musk": "Schoon, poederig en zacht sensueel",
  "amber": "Warm, zoet en omhullend",

  // ======================== ZOET & GOURMAND ========================
  "vanille": "Zoet, warm en troostend",
  "zwarte-vanilleboon": "Intens, rijp en diep vanilleachtig",
  "bourbon-vanille": "Premium Madagaskar vanille, rijk en crèmig",
  "honing": "Gouden, zoet en natuurlijk",
  "karamel": "Gebrand, zoet en verleidelijk",
  "chocolade": "Rijk, bitter-zoet en decadent",
  "cacao": "Puur, intens en ongezoet chocoladeachtig",
  "koffie": "Gebrande bonen, energiek en aromatisch",
  "capuccino": "Romig, koffie met een vleugje melkschuim",
  "marshmallow": "Luchtig, zoet en kinderlijk",
  "suiker": "Puur, kristalhelder zoet",
  "suikerriet": "Natuurlijk, ruw en tropisch zoet",
  "praline-vulling": "Nootachtig, zoet en Belgisch",
  "melk": "Crèmig, zacht en troostend",
  "melk-mousse": "Luchtig, romig en zacht zoet",
  "strawberry-smores": "Kampvuurlekkernij met aardbei",
  "tonkaboon": "Amandel-vanilleachtig, warm en zoet",

  // ======================== LEER & TABAK ========================
  "leer": "Dierlijk, warm en luxueus",
  "tabak": "Droog, gerookt en mannelijk warm",
  "tabaksplantblad": "Groen, vers tabaksblad voor het drogen",

  // ======================== OVERIG ========================
  "zee-noten": "Ziltig, fris en oceanisch",
  "zout": "Mineraal, fris en zeebries-achtig",
  "aldehyden": "Sprankelend, zeepachtig en retro-glamour",
  "calone": "Waterig, fris en oceanisch synthetisch",
  "huid": "Warm, intiem en sensueel",
  "orris-wortel": "Poederig, viooltjesachtig en kostbaar",
  "davana": "Fruitig-kruidig, uniek en complex",
  "cashmeran": "Zacht, muskusachtig en fluwelig warm",
  "sylkolide": "Modern, schoon en muskusachtig",
  "kastanje": "Warm, nootachtig en herfstachtig",
  "amandel": "Zacht, nootachtig en licht zoet",
  "kassieboom": "Kaneelachtig, zoet en aromatisch",
  "jeneverbes": "Fris, gin-achtig en aromatisch",
  "zoethout": "Zoet, anijsachtig en medicinaal",
  "absinth-alsem": "Bitter, kruidig en mysterieus groen",
  "sklareen": "Kruidig, muskusachtig en ontspannend",
  "scharlei": "Aromatisch, kruidig en medicinaal",
  "papyrus": "Droog, papierachtig en antiek",
  "papyrusriet": "Waterig, groen en Egyptisch oud",
  "cognac": "Warm, gedistilleerd en luxueus",
  "drank": "Alcoholisch, warm en feestelijk",
  "cypriol-olie": "Aards, rokerig en oosters houtig",
  "west-indische-laurier": "Kruidig, aromatisch en bay-rum achtig",
  "minerale-noten": "Steenachtig, fris en aards",
  "waterachtige-noten": "Fris, helder en vloeibaar",
  "vlas": "Zacht, natuurlijk en textielachtig",
  "marojaan": "Zoet, kruidig en mediterraan",
  "tahitiaanse-vetiver": "Eiland-vetiver, fris en tropisch",
  "haitiaanse-vetiver": "Aards, rokerig en diep geworteld",
  "bourbon-vetiver": "Premium vetiver, complex en verfijnd",

  // ======================== AANVULLENDE NOTEN ========================
  // Varianten en alternatieve spellingen
  "patchouli": "Aards, kruidig en mysterieus donker",
  "zeenoten": "Ziltig, fris en oceanisch",
  "zee-noten": "Ziltig, fris en oceanisch",
  "lychees": "Exotisch, bloemig-fruitig en delicaat",
  "bramen": "Donker, sappig en bosachtig fruitig",
  "berkehout": "Licht, aromatisch en subtiel houtig",
  "denneboom": "Fris, harzig en bosrijk groen",
  "marshmellow": "Luchtig, zoet en kinderlijk",
  "geranium": "Rozig, kruidig met een groene ondertoon",

  // Extra bloemige noten
  "suede": "Zacht, poederig en fluweelachtig warm",
  "mos": "Aards, groen en bosachtig fris",
  "helder-hout": "Licht, fris en transparant houtig",
  "kerkwierook": "Heilig, mystiek en ceremonieel rokerig",
  "bloed-mandarijn": "Diep oranje-rood, intens en zoet citrus",
  "kruidige-geurnoten": "Mix van warme, aromatische specerijen",
  "hout-noten": "Warme, aardse houtmix",
  "indiase-patchouli": "Rijk, intens en donker aards uit India",
  "rood-fruit": "Mix van rijpe rode bessen en vruchten",
  "rabarber": "Fris, zuur-zoet en fruitig groen",
  "oranje-bloesem": "Zoet, honingachtig en zomers bloemig",
  "slagroom": "Romig, zacht en luchtig zoet",
  "zwarte-bes": "Intens, donker en fruitig-groen",
  "plumeria": "Tropisch, crèmig en exotisch Hawaii-bloem",
  "kamperfoelie": "Zoet, honingachtig en nostalgisch bloemig",
  "kasjmier-hout": "Zacht, warm en luxueus houtig",
  "meloen": "Fris, zoet en zomers waterig",
  "guave": "Tropisch, zoet-zuur en exotisch fruitig",
  "waterlelie": "Waterig, fris en sereen bloemig",
  "passiebloem": "Exotisch, bloemig met een tropische vibe",
  "rozenhout": "Rozig-houtig, elegant en subtiel bloemig",
  "anjer": "Kruidig, pepperig en warm bloemig",
  "rode-bessen": "Fris, zoet-zuur en helder rood fruitig",
  "bloedgrapefruit": "Roze-rood, bitter-zoet en sappig citrus",
  "indiase-mandarijn": "Zoet, warm en exotisch citrus",
  "groene-noten": "Fris, bladachtig en natuurlijk groen",
  "viooltjesblad": "Groen, poederig en delicaat bloemig",
  "sering": "Zoet, romantisch en lentachtig paars-bloemig",
  "karo-karounde": "Exotisch, tropisch en intens bloemig",
  "gojibessen": "Zoet-zuur, rood en superfruit-achtig",
  "kweepeer": "Zacht, honingachtig en aromatisch fruitig",
  "vanille-orchidee": "Exotisch, crèmig met vanille-zoetheid",
  "roze-pioen": "Romantisch, fris en elegant roze bloemig",
  "osmanthus": "Abrikoos-achtig, bloemig en Aziatisch",
  "eikenmos": "Aards, bosachtig en groen-houtachtig",
  "mahoniehout": "Rijk, warm en roodbruin luxe hout",
  "olijfboom": "Groen, mediterraan en aromatisch houtachtig",
  "maninka": "Tropisch, fruitig en exotisch Afrikaans",
  "fruitige-noten": "Mix van zoete, sappige vruchten",
  "afrikaanse-oranjebloesem": "Intens, zoet en exotisch bloemig",
  "amalfi-citroen": "Italiaanse citroen, zonnig en authentiek",
  "cassis": "Intens, donker en zoet-zuur besachtig",
  "heliotroop": "Zoet, amandel-vanilleachtig en poederig bloemig",
  "iriswortel": "Poederig, viooltjesachtig en kostbaar",
  "styrax": "Warm, balsemisch en harsachtig zoet",
  "tabaksblad": "Groen, vers en aromatisch bladachtig",
  "laurierblad": "Aromatisch, kruidig en mediterraan groen",
  "ambergris": "Ziltig, dierlijk en oceanisch warm",
  "roze-grapefruit": "Zoet-bitter, roze en verfrissend citrus",
  "siciliaanse-bergamot": "Fris, elegant en Italiaans citrus",
  "patchouli-uit-singapore": "Verfijnd, oosters en rijk aards",
  "civet": "Dierlijk, muskusachtig en sensueel",
  "zwart-viooltje": "Donker, mysterieus en intens bloemig",
  "chinotto": "Bitter-zoet, citrus en Italiaans aromatisch",
  "madagascar-peper": "Warm, exotisch en intens pepperig",
  "pepperwood": "Houtig, kruidig met een peppernoot",
  "calabrische-bergamot": "Zuivere, frisse Zuid-Italiaanse citrus",
  "waternoten": "Fris, helder en aquatisch",
  "vijgenblad": "Groen, melkachtig en mediterraan fris",
  "grapefruit-bloesem": "Delicaat, citrus-bloemig en fris",
  "rode-besblad": "Groen, fris met een rode-bes ondertoon"
};

// Automatisch tooltips toepassen wanneer DOM geladen is
document.addEventListener('DOMContentLoaded', function() {
  applyNoteTooltips();
});

// Functie om tooltips toe te passen op alle note elementen
function applyNoteTooltips() {
  // Selecteer alle note-item elementen
  const noteElements = document.querySelectorAll('.note-item');

  noteElements.forEach(el => {
    // Haal de note naam uit de class (note-bergamot -> bergamot)
    const classes = el.className.split(' ');
    const noteClass = classes.find(c => c.startsWith('note-') && c !== 'note-item');

    if (noteClass) {
      const noteName = noteClass.replace('note-', '');
      const tooltip = ScentTooltips[noteName];
      const currentTooltip = el.getAttribute('data-tooltip') || '';

      // Overschrijf als we een tooltip hebben EN de huidige tooltip is
      // leeg of bevat alleen de naam van de noot (geen echte beschrijving)
      const noteText = el.textContent.trim();
      const needsTooltip = !currentTooltip ||
                          currentTooltip === noteText ||
                          currentTooltip.length < 30;

      if (tooltip && needsTooltip) {
        el.setAttribute('data-tooltip', tooltip);
        el.classList.add('tooltip-note');
      }
    }
  });
}

// Maak functie globaal beschikbaar voor dynamische content
window.applyNoteTooltips = applyNoteTooltips;
window.ScentTooltips = ScentTooltips;
